import { useQuery, keepPreviousData, useMutation, UseQueryOptions } from '@tanstack/react-query'
import { Document } from '../../shared/types'
import { del, get, post, put } from '../fetch'
import { ParamsType } from '../scaffolding/types'

export type DocumentsParamsType = {
	id?: string
	name?: string
}

export function useDocumentsList(searchParams: ParamsType & DocumentsParamsType) {
	return useQuery({
		queryKey: ['api/document', searchParams],
		queryFn: () => post<{ total: number; list: Document[] }>(`/api/0/document`, searchParams),
		placeholderData: keepPreviousData,
	})
}

export function useDocumentListAll<T = Document[]>(
	options?: Omit<UseQueryOptions<Document[], Error, T>, 'queryKey' | 'queryFn'>,
) {
	return useQuery({
		...options,
		queryKey: ['api/document'],
		queryFn: () => get<Document[]>(`/api/0/document`),
	})
}

export function useDocumentGet(id?: string) {
	return useQuery({
		queryKey: ['api/document', id],
		queryFn: () => get<Document>(`/api/0/document/${id}`),
		enabled: !!id,
	})
}

export function useDocumentInspect(id?: string) {
	return useQuery({
		queryKey: ['api/document/inspect', id],
		queryFn: () => get<Document>(`/api/0/document/${id}/inspect`),
		enabled: !!id,
	})
}

export function useDocumentCreate() {
	return useMutation({
		mutationFn: (data: FormData) => put('/api/0/document', data),
		meta: {
			invalidateQueries: [['api/document']],
			notifications: {
				success: () => 'Dokument vytvořen',
			},
		},
	})
}

export function useDocumentUpdate(id: string) {
	return useMutation({
		mutationFn: (data: FormData) => post(`/api/0/document/${id}`, data),
		meta: {
			invalidateQueries: [['api/document']],
			notifications: {
				success: () => 'Změny uloženy',
			},
		},
	})
}

export function useDocumentRemove() {
	return useMutation({
		mutationFn: (id: string) => del(`/api/0/document/${id}`),
		meta: {
			invalidateQueries: [['api/document']],
			notifications: {
				success: () => 'Dokument smazán',
			},
		},
	})
}
